import { useState } from "react";
import { BtnRoomBookingSentWidgetStyled } from "./styled";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTE_PATH } from "utils/constants/routePath";
import { userService } from "apiServices";
import { RENDER_API_ERROR_MESSAGE } from "utils/functions/roomBooking";
import { useTranslation } from "react-i18next";
import { Buttons, Displays } from "components";

const BtnRoomBookingSentWidget = ({ room_booking_id }) => {
  const navigate = useNavigate();
  const { id } = useParams(); // room id จาก route ของ step ที่ widget นี้ถูกวางอยู่
  const { t } = useTranslation(["common"]);

  const [_isBgLoading, _setIsBgLoading] = useState(false);

  const _handleSent = async () => {
    _setIsBgLoading(true);
    let params = {
      room_booking_id: room_booking_id,
    };
    let res = await userService.POST_ROOM_BOOKING_SENT(params);
    if (res && res.status === 200) {
      _setIsBgLoading(false);
      toast.success(t("Room booking successfully", { ns: "common" }));
      // ส่ง room_id ไปด้วย เพื่อให้หน้าขอบคุณกดกลับมาที่หน้าห้องนั้นแล้วเห็นสถานะการจองได้
      // replace เพื่อไม่ให้กด back ของ browser ย้อนกลับเข้า wizard โหมด preview ได้อีก
      navigate(
        `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE_THANK_YOU}${
          id ? `?room_id=${id}` : ""
        }`,
        { replace: true },
      );
    } else {
      _setIsBgLoading(false);
      toast.error(
        RENDER_API_ERROR_MESSAGE(res, t("Room booking failed", { ns: "common" })),
      );
    }
  };
  return (
    <BtnRoomBookingSentWidgetStyled>
      <Displays.BGLoading visible={_isBgLoading} />
      <Buttons.BgStandard
        label={t("Confirm and Submit", { ns: "common" })}
        height={"48px"}
        onClick={_handleSent}
      />
    </BtnRoomBookingSentWidgetStyled>
  );
};

export default BtnRoomBookingSentWidget;
